import { useMutation, useQueryClient } from '@tanstack/react-query'
import { importLinkedinProfiles, searchLinkedin } from '../services/api.js'
import { refreshCreditsDisplay } from '../utils/creditsHelper.js'

/**
 * Prospection LinkedIn : lancer une recherche (tâche du worker) et ajouter au CRM les profils choisis.
 * Le suivi de la tâche passe par useWorkerJob ; les prospects ajoutés rafraîchissent le CRM.
 */
export function useLinkedinSearch() {
  const queryClient = useQueryClient()

  const search = useMutation({
    mutationFn: searchLinkedin,
    onSuccess: () => refreshCreditsDisplay(queryClient),
  })

  const importProfiles = useMutation({
    mutationFn: importLinkedinProfiles,
    onSuccess: () => {
      refreshCreditsDisplay(queryClient)
      queryClient.invalidateQueries({ queryKey: ['myProspects'] })
    },
  })

  return { search, importProfiles }
}
